// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ldcomEntity from './entities/ldcom.json';
import ldcomMenu from '../pages/ldcom/menu.json';
import ldcomFullForm from '../pages/ldcom/forms/full.json';
import ldcomContextForm from '../pages/ldcom/forms/context.json';
import ldcomMiniForm from '../pages/ldcom/forms/mini.json';
import ldcomLookupForm from '../pages/ldcom/forms/lookup.json';
import ldcomTableView from '../pages/ldcom/views/table.json';
import ldcomStagesView from '../pages/ldcom/views/stages.json';
import ldcomCardsView from '../pages/ldcom/views/cards.json';
import ldcomInlineView from '../pages/ldcom/views/inline.json';
import ldcomBacklogView from '../pages/ldcom/views/backlog.json';
import ldcomSplitView from '../pages/ldcom/views/split.json';
import ldcomCalendarView from '../pages/ldcom/views/calendar.json';
import ldcomDashboardView from '../pages/ldcom/views/dashboard.json';

/** Тип запису «Коментар до тексту» зі сторінками пакета: меню, форми та подання з pages/ldcom/. */
export const ldcomDefinition: IRecordTypeDefinition = {
  ...ldcomEntity,
  views: assembleViewSet({
      table: ldcomTableView,
      stages: ldcomStagesView,
      cards: ldcomCardsView,
      inline: ldcomInlineView,
      backlog: ldcomBacklogView,
      split: ldcomSplitView,
      calendar: ldcomCalendarView,
      dashboard: ldcomDashboardView,
  }),
  form: ldcomFullForm,
  forms: { full: ldcomFullForm, context: ldcomContextForm, mini: ldcomMiniForm, lookup: ldcomLookupForm },
  menu: ldcomMenu,
} as IRecordTypeDefinition;
